<template>
  <AppSidebar />
  <div class="wrapper d-flex flex-column min-vh-100 bg-light dark:bg-transparent">
    <AppHeader />
    <div class="body flex-grow-1 px-3">
      <CContainer lg>
        <AppBreadcrumb />
        <router-view />
      </CContainer>
    </div>
    <AppFooter />
  </div>
  <CButton  v-c-tooltip="'Your Portals & Apps'" @click="visibleOffcanvas = true" class="floating-apps">
    <img :src="AppsIco" alt="Apps" />
  </CButton>
  <COffcanvas id="offcanvasNavbar" placement="end" :visible="visibleOffcanvas" @hide="visibleOffcanvas = false">
    <COffcanvasHeader>
      <COffcanvasTitle>Your Portals & Apps</COffcanvasTitle>
      <CCloseButton class="text-reset" @click="visibleOffcanvas = false" />
    </COffcanvasHeader>
    <COffcanvasBody>
      <CNavLink href="https://warehouse.connectco.me/#/pages/sso" target="_blank">
        <CCard class="card-list">
          <CCardImage orientation="top" src="/images/general/new-setup2.jpg" />
          <CCardBody>
            <CCardTitle>Warehouse Portal</CCardTitle>
            <p class="text-medium-emphasis small">
              Manage Advance shipment notices quality checking, Inventory stock-in and shelving, Order processing,
              picking, sorting, quality checks and returns, Track orders and assign delivery - all in one portal.
            </p>
            <CButton color="primary">
              <CIcon icon="cil-external-link" />&nbsp;&nbsp;&nbsp;Warehouse Portal
            </CButton>
          </CCardBody>
        </CCard>
      </CNavLink>
      <CNavLink href="https://delivery.connectco.me/#/pages/sso" target="_blank">
        <CCard class="card-list" >
          <CCardImage orientation="top" src="/images/general/new-setup3.jpg" />
          <CCardBody>
            <CCardTitle>Delivery Portal</CCardTitle>
            <p class="text-medium-emphasis small">
              Manage orders, shipments, delivery - all in one place!
            </p>
            <CButton color="primary">
              <CIcon icon="cil-external-link" />&nbsp;&nbsp;&nbsp;Delivery Portal
            </CButton>
          </CCardBody>
        </CCard>
      </CNavLink>
      <CNavLink
        @click="() => { this.appTypeModal = 'ConnectCo+ Delivery App'; this.linkQRCodeModal = this.deliveryAppQRURL; this.viewQRModal = true; }">
        <CCard class="card-list">
          <CCardImage orientation="top" :src="this.deliveryAppQRURL" />
          <CCardBody>
            <CCardTitle>ConnectCo+ Delivery App</CCardTitle>
            <p class="text-medium-emphasis small mb-0">
              Manage orders, shipments, delivery - all in one place!<br>
              <strong>Scan QR code</strong> to Download mobile app
            </p>
          </CCardBody>
        </CCard>
      </CNavLink>
      <CNavLink
        @click="() => { this.appTypeModal = 'ConnectCo+ Warehouse App'; this.linkQRCodeModal = this.warehouseAppQRURL; this.viewQRModal = true; }">
        <CCard class="card-list">
          <CCardImage orientation="top" :src="this.warehouseAppQRURL" />
          <CCardBody>
            <CCardTitle>ConnectCo+ Warehouse App</CCardTitle>
            <p class="text-medium-emphasis small mb-0">
              Assign locations, Pick orders from the convenience of mobile app!<br>
              <strong>Scan QR code</strong> to Download mobile app
            </p>
          </CCardBody>
        </CCard>
      </CNavLink>
    </COffcanvasBody>
  </COffcanvas>
  <CModal backdrop="static" :keyboard="false" :visible="this.viewQRModal" class="modalOpacity"
    @close="() => { this.viewQRModal = false; visibleOffcanvas = true }">
    <CModalHeader>
      <CModalTitle>Scan QR Code to Download</CModalTitle>
    </CModalHeader>
    <CModalBody>
      <CAlert color="primary text-center">
        <span class="h5">
          {{ this.appTypeModal }}
        </span>
      </CAlert>
      <CCardImage orientation="top" :src="this.linkQRCodeModal" />
    </CModalBody>
    <CModalFooter>
      <CButton color="secondary" @click="() => { this.viewQRModal = false; visibleOffcanvas = true }">Close</CButton>
    </CModalFooter>
  </CModal>
  <!-- <AppAside /> -->
</template>
<script>
import AppsIco from '@/assets/images/apps_ic.svg';
import { CContainer } from '@coreui/vue-pro'
import AppAside from '@/components/AppAside.vue'
import AppBreadcrumb from '@/components/AppBreadcrumb.vue'
import AppFooter from '@/components/AppFooter.vue'
import AppHeader from '@/components/AppHeader.vue'
import AppSidebar from '@/components/AppSidebar.vue'

export default {
  name: 'DefaultLayout',
  data() {
    return {
      appTypeModal: null,
      viewQRModal: false,
      visibleOffcanvas: false,
      linkQRCodeModal: null,
      deliveryAppQRURL: "https://wms-s3-assets-bc-rss-hkhaled-prod.s3.ap-south-1.amazonaws.com/Artifacts/delivery-app-qr-code.png",
      warehouseAppQRURL: "https://wms-s3-assets-bc-rss-hkhaled-prod.s3.ap-south-1.amazonaws.com/Artifacts/warehouse-app-qr-code.png",
    }
  },
  components: {
    AppAside,
    AppBreadcrumb,
    AppFooter,
    AppHeader,
    AppSidebar,
    CContainer,
  },
  computed: {
    AppsIco() {
      return AppsIco
    },
  },
}
</script>
<style scoped>
.floating-apps {
  position: fixed;
  bottom: 10px;
  right: 10px;
  background-color: #b8db22;
  border: 0px;
  border-radius: 50%;
  width: 50px;
  height: 50px;
}
.card.card-list{
  box-shadow: rgb(50 50 93 / 20%) 0 2px 5px -1px, rgba(0, 0, 0, 0.2) 0 1px 3px -1px;
  margin-bottom: 20px;  
}
</style>
